import React from "react";
import Loadable from "react-loadable";
import DefaultLayout from "./containers/DefaultLayout";
import _ from 'lodash';
// import LoadingCircular from "./components/LoadingCircular";
import { reactLocalStorage } from "reactjs-localstorage";
import { getRegion } from "./helper/functions/functions";
import { LoadingComponent } from "./components/LoadingComponent";
import { RegionOption } from './helper/constants/options';
import { LSNAME } from "./helper/constants/constants.js";

function Loading() {
  return <LoadingComponent show={true} position="center" />;
}

// function Loading() {
//   return <div>Loading....</div>;
// }

const Dashboard = Loadable({
  loader: () => import("./views/Dashboard"),
  loading: Loading
});

const Analytics = Loadable({
  loader: () => import("./views/Analytics/AnalyticsHome"),
  loading: Loading
});

const UserJourney = Loadable({
  loader: () => import("./views/Analytics/UserJourney/UserJourneyList"),
  loading: Loading
});

const LogCalls = Loadable({
  loader: () => import("./views/LogCalls/LogCalls"),
  loading: Loading
});

const AddLogCall = Loadable({
  loader: () => import("./views/LogCalls/AddLogCall"),
  loading: Loading
});

const LogCallsHistory = Loadable({
  loader: () => import("./views/LogCalls/LogCallHistory"),
  loading: Loading
});

const Users = Loadable({
  loader: () => import("./views/Users/Users"),
  loading: Loading
});

const User = Loadable({
  loader: () => import("./views/Users/UserDetail/UserDetailHome"),
  loading: Loading
});

const Vouchers = Loadable({
  loader: () => import("./views/Vouchers/Vouchers"),
  loading: Loading
});

const AddVoucher = Loadable({
  loader: () => import("./views/Vouchers/AddVoucher"),
  loading: Loading
});

const Admins = Loadable({
  loader: () => import("./views/Admins/Admins"),
  loading: Loading
});

const ImeiException = Loadable({
  loader: () => import("./views/Admins/ImeiException/ImeiException"),
  loading: Loading
});
const AddImeiException = Loadable({
  loader: () => import("./views/Admins/ImeiException/AddImeiException"),
  loading: Loading
});


// const AddAdmin = Loadable({
//   loader: () => import("./views/Admins/AddAdmin"),
//   loading: Loading
// });

const AdminHome = Loadable({
  loader: () => import("./views/Admins/AdminHome"),
  loading: Loading
});

const Role = Loadable({
  loader: () => import("./views/Admins/Roles/Role"),
  loading: Loading
});

const AddRole = Loadable({
  loader: () => import("./views/Admins/Roles/AddRole"),
  loading: Loading
})

const JDCategories = Loadable({
  loader: () => import("./views/JDCategories/JDCategories"),
  loading: Loading
});
const AddJDCategory = Loadable({
  loader: () => import("./views/JDCategories/AddJDCategory"),
  loading: Loading
});

const DigitalCategories = Loadable({
  loader: () => import("./views/DigitalCategories/DigitalCategories"),
  loading: Loading
});
// const AddDigitalCategory = Loadable({
//   loader: () => import("./views/DigitalCategories/AddDigitalCategory"),
//   loading: Loading
// });

const DigitalProducts = Loadable({
  loader: () => import("./views/DigitalProducts/DigitalProducts"),
  loading: Loading
});

// const ProductRequest = Loadable({
//   loader: () => import("./views/DigitalProducts/ProductRequest"),
//   loading: Loading
// });

const AddDigitalProduct = Loadable({
  loader: () => import("./views/DigitalProducts/AddDigitalProduct"),
  loading: Loading
});

const JDProducts = Loadable({
  loader: () => import("./views/JDProducts/JDProducts"),
  loading: Loading
});

const JDProduct = Loadable({
  loader: () => import("./views/JDProducts/JDProduct"),
  loading: Loading
});

const DigitalBrands = Loadable({
  loader: () => import("./views/DigitalBrands/DigitalBrands"),
  loading: Loading
});
const AddDigitalBrand = Loadable({
  loader: () => import("./views/DigitalBrands/AddDigitalBrand"),
  loading: Loading
});

const Orders = Loadable({
  loader: () => import("./views/Orders/Orders"),
  loading: Loading
});

const OrderDetail = Loadable({
  loader: () => import("./views/Orders/OrderDetail/OrderDetailHome"),
  loading: Loading
});

const Coupons = Loadable({
  loader: () => import("./views/Marketings/Coupons/Coupons"),
  loading: Loading
});

const AddCoupon = Loadable({
  loader: () => import("./views/Marketings/Coupons/AddCoupon"),
  loading: Loading
});

const Referrals = Loadable({
  loader: () => import("./views/Marketings/Referrals/Referrals"),
  loading: Loading
});

const Banners = Loadable({
  loader: () => import("./views/Marketings/Banners/Banners"),
  loading: Loading
});

const AddBanner = Loadable({
  loader: () => import("./views/Marketings/Banners/AddBanner"),
  loading: Loading
});

const PopUpBanners = Loadable({
  loader: () => import("./views/Marketings/Banners/PopupBanners"),
  loading: Loading
});

const AddPopupBanner = Loadable({
  loader: () => import("./views/Marketings/Banners/AddPopupBanners"),
  loading: Loading
});

const HomePage = Loadable({
  loader: () => import("./views/Marketings/HomePage/HomePage"),
  loading: Loading
});

const Collections = Loadable({
  loader: () => import("./views/Collections/CollectionHome"),
  loading: Loading
});

const AddGeneral = Loadable({
  loader: () =>
    import("./views/Collections/CollectionGeneral/AddCollectionGeneral"),
  loading: Loading
});

const Settings = Loadable({
  loader: () => import("./views/Settings/SettingHome"),
  loading: Loading
});

const SettlementReport = Loadable({
  loader: () => import("./views/Reports/SettlementReports/SettlementReport"),
  loading: Loading
});

const PartnerMerchantReport = Loadable({
  loader: () => import("./views/Reports/PartnerMerchantReport/PartnerMerchantReport"),
  loading: Loading
});

const MerchantSettlementReport = Loadable({
  loader: () => import("./views/Reports/MerchantSettlementReport/MerchantSettlementReport.js"),
  loading: Loading
});

const PaymentReports = Loadable({
  loader: () => import("./views/Reports/PaymentReports/PaymentReports"),
  loading: Loading
});

const AddSeller = Loadable({
  loader: () => import("./views/Reports/PurchaseReport/Components/AddSeller"),
  loading: Loading
});

const SaldokuReports = Loadable({
  loader: () => import("./views/Reports/SaldokuReports/SaldokuReports"),
  loading: Loading
});

const Topups = Loadable({
  loader: () => import("./views/Topups/Topups"),
  loading: Loading
});

// const HPHongkong = Loadable({
//   loader: () => import("./views/HPHongkong/HPHongkong"),
//   loading: Loading
// });

// const AddHPHongkong = Loadable({
//   loader: () => import("./views/HPHongkong/AddHPHongkong"),
//   loading: Loading
// });

// const OrderRequest = Loadable({
//   loader: () => import("./views/OrderRequest/OrderRequest.js"),
//   loading: Loading
// })

// const HPHongkongSettlement = Loadable({
//   loader: () => import("./views/HPHongkongReport/HPHongkongReport.js"),
//   loading: Loading
// })

const ListMerchant = Loadable({
  loader: () => import("./views/Merchant/MerchantList/MerchantIndex"),
  loading: Loading
})

const MerchantOrder = Loadable({
  loader: () => import("./views/Merchant/MerchantOrder/MerchantOrders"),
  loading: Loading
})

// const MerchantSettlement = Loadable({
//   loader: () => import("./views/Merchant/MerchantManagement/MerchantSettlement"),
//   loading: Loading
// })

const AddNewMerchant = Loadable({
  loader: () => import("./views/Merchant/MerchantList/AddNewMerchant"),
  loading: Loading
})

const MerchantProductRequest = Loadable({
  loader: () => import("./views/Merchant/MerchantProductRequest/MerchantProductRequest"),
  loading: Loading
})

const MerchantProductList = Loadable({
  loader: () => import("./views/Merchant/MerchantProduct/MerchantProduct"),
  loading: Loading
});

const MerchantSalesReport = Loadable({
  loader: () => import("./views/Merchant/MerchantReport/MerchantSalesReport"),
  loading: Loading
})

const JDSaleReports = Loadable({
  loader: () => import("./views/Reports/JDSaleReports/jdSaleReports"),
  loading: Loading
})

const DigitalSaleReports = Loadable({
  loader: () => import("./views/Reports/DigitalSaleReports/digitalSaleReports"),
  loading: Loading
})

const RefundSaleReports = Loadable({
  loader: () => import("./views/Reports/RefundReport/refundReport"),
  loading: Loading
})

const UserReports = Loadable({
  loader: () => import("./views/Reports/UserReport/UserReport"),
  loading: Loading
})

const PaymentOrderReports = Loadable({
  loader: () => import("./views/Reports/PaymentOrderReports/PaymentOrderReport"),
  loading: Loading
})

const TokenContactReport = Loadable({
  loader: () => import("./views/Reports/TokenContactReport/TokenContactReport"),
  loading: Loading
})

const AttendanceReports = Loadable({
  loader: () => import("./views/Attendance/AttendanceReport"),
  loading: Loading
})

const GiftReports = Loadable({
  loader: () => import("./views/Reports/GiftReports/GiftReports"),
  loading: Loading
})

const Notifications = Loadable({
  loader: () => import("./views/Marketings/Notifications/Notifications"),
  loading: Loading
})

const NotificationHome = Loadable({
  loader: () => import("./views/Marketings/Notifications/NotificationHome"),
  loading: Loading
})

// const AdminLeaveInfo = Loadable({
//   loader: () => import("./views/Admins/AdminLeave/AdminLeave"),
//   loading: Loading
// })

const SalesTakeOrderReport = Loadable({
  loader: () => import("./views/Reports/SalesOrderReport/SalesOrderReport"),
  loading: Loading
})

const CouponReport = Loadable({
  loader: () => import("./views/Reports/CouponOrderReport/CouponReport"),
  loading: Loading
})

const SettingsSuspiciousContactAdd = Loadable({
  loader: () => import("./views/Settings/SuspiciousNumber/SuspiciousNumberDetail"),
  loading: Loading
})

const TrendProduct = Loadable({
  loader: () => import("./views/Reports/TrendProduct/TrendProduct"),
  loading: Loading
})
const OrderAllReport = Loadable({
  loader: () => import("./views/Orders/OrderAllReport/OrderAllReport"),
  loading: Loading
})
const CollectorReports = Loadable({
  loader: () => import("./views/Reports/CollectorsReport/CollectorsReports"),
  loading: Loading
})
const LogContactReport = Loadable({
  loader: () => import("./views/Reports/LogContactReport/ReportLogContact"),
  loading: Loading
});
const SMSServerList = Loadable({
  loader: () => import("./views/SMSServer/SmsServerList"),
  loading: Loading
})
const SMSServer = Loadable({
  loader: () => import("./views/SMSServer/SmsServerHome"),
  loading: Loading
});
const OTPiDeal = Loadable({
  loader: () => import("./views/SMSServer/OTPSMSServer/OTPSmsServer"),
  loading: Loading
})
const Affiliate = Loadable({
  loader: () => import("./views/Affiliate/Affiliate"),
  loading: Loading
})
const AddAffiliate = Loadable({
  loader: () => import("./views/Affiliate/AddAffiliate"),
  loading: Loading
})
const AffiliateDetail = Loadable({
  loader: () => import("./views/Affiliate/AffiliateDetail/AffiliateDetailHome"),
  loading: Loading
})
const WithdrawRequest = Loadable({
  loader: () => import("./views/WithdrawRequest/withdrawRequest"),
  loading: Loading
})
const UserListLastActive = Loadable({
  loader: () => import("./views/UserLastActive/UserListLastActive"),
  loading: Loading
})
const CMSLogReport = Loadable({
  loader: () => import("./views/CMSLog/CMSLog"),
  loading: Loading
})
const SevelReport = Loadable({
  loader: () => import("./views/Reports/SevelReport/SevelReport"),
  loading: Loading
})
const OKMartReport = Loadable({
  loader: () => import("./views/Reports/VendorPaymentReport/OKMartReport/OKMartReport"),
  loading: Loading
})
const FamiliMartReport = Loadable({
  loader: () => import("./views/Reports/VendorPaymentReport/FamiliMartReport/FamMartReport"),
  loading: Loading
})
const KPI = Loadable({
  loader: () => import("./views/KPI/KPIHome"),
  loading: Loading
})

const TimeTable = Loadable({
  loader: () => import("./views/TimeTable/TimeTableHome"),
  loading: Loading
})
const LocalStore = Loadable({
  loader: () => import("./views/LocalStore/LocalStore"),
  loading: Loading
})
const AddLocalStore = Loadable({
  loader: () => import("./views/LocalStore/AddLocalStore"),
  loading: Loading
})
const Translate = Loadable({
  loader: () => import("./views/Translate/Translate"),
  loading: Loading
})

const GiveawayList = Loadable({
  loader: () => import("./views/Marketings/Giveaway/GiveawayList"),
  loading: Loading
})
const AddGiveaway = Loadable({
  loader: () => import("./views/Marketings/Giveaway/AddGiveaway/AddGiveaway"),
  loading: Loading
})
const ProductsPromo = Loadable({
  loader: () => import("./views/Marketings/Promo/PromoList"),
  loading: Loading
})
const AddProductsPromo = Loadable({
  loader: () => import("./views/Marketings/Promo/ProductsPromo"),
  loading: Loading
})
const ShortenLink = Loadable({
  loader: () => import("./views/Marketings/ShortenLink/ShortenLink"),
  loading: Loading
})
const ChatHome = Loadable({
  loader: () => import("./views/Chat/ChatHome"),
  loading: Loading
})
const ChatMessages = Loadable({
  loader: () => import("./views/Chat/ChatMessages"),
  loading: Loading
})
const Monitoring = Loadable({
  loader: () => import("./views/Monitoring/MonitoringMain"),
  loading: Loading
});
const EditProfile = Loadable({
  loader: ()=> import("./views/Settings/SettingProfile/EditProfile"),
  loading: Loading
});
const ChatReport = Loadable({
  loader: () => import("./views/Reports/ChatReport/ChatReports"),
  loading: Loading
});
const GoodReport = Loadable({
  loader: () => import("./views/Reports/CreditRecord/CreditRecordUser"),
  loading: Loading
})
const OAReport = Loadable({
  loader: () => import("./views/Reports/OAReport/OAReport"),
  loading: Loading
})
const PurchaseReport = Loadable({
  loader: () => import("./views/Reports/PurchaseReport/PurchaseReport"),
  loading: Loading
})

// const FontAwesome = Loadable({
//   loader: () => import("./views/Icons/FontAwesome/FontAwesome.js"),
//   loading: Loading
// })
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const region = getRegion();

let routes = [
  { path: "/", exact: true, name: "Home", component: DefaultLayout },
  { path: `/${region}/dashboard`, name: "Dashboard", component: Dashboard },
  {
    path: `/${region}/analytics`,
    exact: true,
    name: "Analytics+",
    component: Analytics
  },
  {
    path: `/monitoring`,
    exact: true,
    name: "Monitoring",
    component: Monitoring
  },
  {
    path: "/analytics/userjourney",
    exact: true,
    name: "User Journey",
    component: UserJourney
  },
  {
    path: `/${region}/editprofile`,
    exact: true,
    name: "EditProfile",
    component: EditProfile
  },
  {
    path: `/${region}/log-calls`,
    exact: true,
    name: "Log Calls",
    component: LogCalls,
    permission: "LOGCALLS_ANY_READ"
  },
  {
    path: `/${region}/log-calls/add`,
    exact: true,
    name: "Add Log Calls",
    component: AddLogCall,
    permission: "LOGCALLS_ANY_CREATE"
  },
  {
    path: `/${region}/log-calls/edit/:logCallId`,
    exact: true,
    name: "Edit Log Calls",
    component: AddLogCall,
    permission: "LOGCALLS_ANY_UPDATE"
  },
  {
    path: `/${region}/log-calls/:logCallId/history`,
    exact: true,
    name: "Log Calls History",
    component: LogCallsHistory,
    permission: "LOGCALLS_ANY_READ"
  },
  {
    path: `/${region}/admins`,
    exact: true, name: "Admins",
    component: Admins,
    permission: "ADMIN_USERS_ANY_READ"
  },
  {
    path: `/${region}/imeiexception`,
    exact: true, name: "IMEI Exception",
    component: ImeiException,
    permission: "ADMIN_USERS_ANY_READ"
  },
  {
    path: `/${region}/imeiexception/add`,
    exact: true, name: "IMEI Exception",
    component: AddImeiException,
    permission: "ADMIN_USERS_ANY_READ"
  },
  {
    path: `/${region}/imeiexception/edit/:adminId/:phonetype`,
    exact: true, name: "IMEI Exception",
    component: AddImeiException,
    permission: "ADMIN_USERS_ANY_READ"
  },
  {
    path: `/${region}/admins/add`,
    exact: true,
    name: "Add Admin",
    component: AdminHome,
    permission: "ADMIN_USERS_ANY_CREATE"
  },
  {
    path: `/${region}/admins/edit/:adminId`,
    exact: true,
    name: "Edit Admin",
    component: AdminHome,
    permission: "ADMIN_USERS_ANY_UPDATE"
  },
  {
    path: `/${region}/kpi`,
    exact: true,
    name: "KPI",
    component: KPI,
  },
  // {
  //   path: `/${region}/timetable`,
  //   exact: true,
  //   name: "Time Table",
  //   component: TimeTable,
  // },
  {
    path: `/${region}/roles`,
    exact: true,
    name: "Role",
    component: Role,
  },
  {
    path: `/${region}/roles/:roleId`,
    exact: true,
    name: "Add Role",
    component: AddRole,
  },
  {
    path: `/${region}/roles/add`,
    exact: true,
    name: "Add Role",
    component: AddRole,
  },
  { path: `/${region}/users`, exact: true, name: "Users", component: Users, permission: "ADMIN_USERS_ANY_READ" },
  {
    path: `/${region}/users/:userId`,
    exact: true,
    name: "User Details",
    component: User,
    permission: "ADMIN_USERS_ANY_READ"
  },
  {
    path: `/${region}/vouchers`,
    exact: true,
    name: "Voucher Management",
    component: Vouchers,
    permission: "VOUCHERS_ANY_READ"
  },
  {
    path: `/${region}/vouchers/add`,
    exact: true,
    name: "Add Voucher",
    component: AddVoucher,
    permission: "VOUCHERS_ANY_CREATE"
  },
  {
    path: `/${region}/categories/id`,
    exact: true,
    name: "ID Categories",
    component: JDCategories,
    permission: "CATEGORIES_ANY_READ"
  },
  {
    path: `/${region}/categories/id/add`,
    exact: true,
    name: "Add ID Category",
    component: AddJDCategory,
    permission: "CATEGORIES_ANY_CREATE"
  },
  {
    path: `/${region}/categories/id/edit/:id`,
    exact: true,
    name: "Edit ID Category",
    component: AddJDCategory,
    permission: "CATEGORIES_ANY_UPDATE"
  },
  {
    path: `/${region}/categories/digital`,
    exact: true,
    name: "Digital Categories",
    component: DigitalCategories,
    permission: "CATEGORIES_ANY_READ"
  },
  // {
  //   path: `/${region}/categories/digital/add`,
  //   exact: true,
  //   name: "Add Digital Category",
  //   component: AddDigitalCategory,
  //   permission: "CATEGORIES_ANY_CREATE"
  // },
  // {
  //   path: `/${region}/categories/digital/edit/:digitalCategoryId`,
  //   exact: true,
  //   name: "Edit Digital Category",
  //   component: AddDigitalCategory,
  //   permission: "CATEGORIES_ANY_UPDATE"
  // },
  {
    path: `/${region}/products/digital`,
    exact: true,
    name: "Digital Products",
    component: DigitalProducts,
    permission: "PRODUCTS_ANY_READ"
  },
  {
    path: `/${region}/products/digital/add`,
    exact: true,
    name: "Add Digital Product",
    component: AddDigitalProduct,
    permission: "PRODUCTS_ANY_CREATE"
  },
  {
    path: `/${region}/products/digital/edit/:digitalProductId`,
    exact: true,
    name: "Edit Digital Product",
    component: AddDigitalProduct,
    permission: "PRODUCTS_ANY_UPDATE"
  },
  {
    path: `/${region}/products/id`,
    exact: true,
    name: "ID Products",
    component: JDProducts,
    permission: "PRODUCTS_ANY_READ"
  },
  {
    path: `/${region}/products/id/:productId`,
    exact: true,
    name: "ID Product Detail",
    component: JDProduct,
    permission: "PRODUCTS_ANY_READ"
  },
  {
    path: `/${region}/brands/digital`,
    exact: true,
    name: "Digital Brands",
    component: DigitalBrands,
    permission: "BRANDS_ANY_READ"
  },
  {
    path: `/${region}/brands/digital/add`,
    exact: true,
    name: "Add Digital Brand",
    component: AddDigitalBrand,
    permission: "BRANDS_ANY_CREATE"
  },
  {
    path: `/${region}/brands/digital/edit/:digitalBrandId`,
    exact: true,
    name: "Edit Digital Brand",
    component: AddDigitalBrand,
    permission: "BRANDS_ANY_UPDATE"
  },
  { path: `/${region}/orders`, exact: true, name: "Orders", component: Orders, permission: "ORDERS_ANY_READ" },
  {
    path: `/${region}/orders/:orderId`,
    exact: true,
    name: "Order Detail",
    component: OrderDetail,
    permission: "ORDERS_ANY_READ"
  },
  {
    path: `/${region}/payments`,
    exact: true,
    name: "Payments",
    component: Topups,
    permission: "TOPUPS_ANY_READ"
  },
  {
    path: `/${region}/marketings/coupons`,
    exact: true,
    name: "Coupons",
    component: Coupons,
    permission: "MARKETING_ANY_READ"
  },
  {
    path: `/${region}/marketings/coupons/add`,
    exact: true,
    name: "Add Coupon",
    component: AddCoupon,
    permission: "MARKETING_ANY_CREATE"
  },
  {
    path: `/${region}/marketings/coupons/edit/:couponId`,
    exact: true,
    name: "Edit Coupon",
    component: AddCoupon,
    permission: "MARKETING_ANY_UPDATE"
  },
  {
    path: `/${region}/marketings/coupons/copy/:copyId`,
    exact: true,
    name: "Add Coupon",
    component: AddCoupon,
    permission: "MARKETING_ANY_UPDATE"
  },
  {
    path: `/${region}/marketings/referrals`,
    exact: true,
    name: "Referrals",
    component: Referrals,
    permission: "MARKETING_ANY_READ"
  },
  // banner
  {
    path: `/${region}/marketings/banners`,
    exact: true,
    name: "Banners",
    component: Banners,
    permission: "MARKETING_ANY_READ"
  },
  {
    path: `/${region}/marketings/banners/edit/:bannerId`,
    exact: true,
    name: "Edit Banner",
    component: AddBanner,
    permission: "MARKETING_ANY_UPDATE"
  },
  {
    path: `/${region}/marketings/banners/add`,
    exact: true,
    name: "Add Banner",
    component: AddBanner,
    permission: "MARKETING_ANY_CREATE"
  },
  {
    path: `/${region}/marketings/popupimages`,
    exact: true,
    name: "Popup Banner",
    component: PopUpBanners,
    permission: "MARKETING_ANY_READ"
  },
  {
    path: "/marketings/broadcast",
    exact: true,
    name: "Broadcast",
    component: Notifications,
    permission: "MARKETING_ANY_READ"
  },
  {
    path: "/marketings/broadcast/add",
    exact: true,
    name: "Add Broadcast",
    component: NotificationHome,
    permission: "MARKETING_ANY_READ"
  },
  {
    path: `/${region}/marketings/popupimages/addpopup`,
    exact: true,
    name: "Add Pop Up Banner",
    component: AddPopupBanner,
    permission: "MARKETING_ANY_CREATE"
  },
  {
    path: `/${region}/marketings/popupimages/editpopup/:bannerId`,
    exact: true,
    name: "Pop up Banner Detail",
    component: AddPopupBanner,
    permission: "MARKETING_ANY_UPDATE"
  },
  {
    path: "/marketings/homepage",
    exact: true,
    name: "iDeal Homepage",
    component: HomePage,
    permission: "MARKETING_ANY_UPDATE"
  },
  {
    path: `/${region}/reports/coupon`,
    exact: true,
    name: "Coupon Order Report",
    component: CouponReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/merchants/listmerchant`,
    exact: true,
    name: "List Merchant",
    component: ListMerchant,
    permission: "ADMIN_USERS_ANY_CREATE",
  },
  {
    path: `/${region}/merchants/merchantorder`,
    exact: true,
    name: "List Merchant Order",
    component: MerchantOrder,
    permission: "VOUCHERS_ANY_READ",
  },
  {
    path: `/${region}/merchants/listmerchant/add`,
    exact: true,
    name: "Add New Merchant",
    component: AddNewMerchant,
    permission: "ADMIN_USERS_ANY_CREATE",
  },
  {
    path: `/${region}/merchants/listmerchant/edit/:merchantId`,
    exact: true,
    name: "Edit Merchant",
    component: AddNewMerchant,
    permission: "ADMIN_USERS_ANY_UPDATE"
  },
  {
    path: `/${region}/merchants/productrequest`,
    exact: true,
    name: "Merchant Product Request",
    component: MerchantProductRequest,
    permission: "ADMIN_USERS_ANY_UPDATE"
  },
  {
    path: `/${region}/merchants/merchantproducts`,
    exact: true,
    name: "Merchant Products",
    component: MerchantProductList,
    permission: "PRODUCTS_ANY_READ",
  },
  {
    path: `/${region}/merchants/merchantproducts/:productId`,
    exact: true,
    name: "Merchant Product Detail",
    component: JDProduct,
    permission: "PRODUCTS_ANY_READ",
  },
  {
    path: `/${region}/collections`,
    exact: true,
    name: "Collections",
    component: Collections,
    permission: "COLLECTIONS_ANY_READ"
  },
  {
    path: `/${region}/collections/generals/add`,
    exact: true,
    name: "Add General Collection",
    component: AddGeneral,
    permission: "COLLECTIONS_ANY_CREATE"
  },
  {
    path: `/${region}/collections/generals/edit/:collectionId`,
    exact: true,
    name: "Edit General Collection",
    component: AddGeneral,
    permission: "COLLECTIONS_ANY_UPDATE"
  },
  {
    path: `/${region}/settings`,
    exact: true,
    name: "Settings",
    component: Settings,
    permission: "SETTINGS_ANY_READ"
  },
  {
    path: `/${region}/settings/suspiciousContact/add`,
    exact: true,
    name: "Suspicious Contact",
    component: SettingsSuspiciousContactAdd,
  },
  {
    path: `/${region}/settings/suspiciousContact/:id`,
    exact: true,
    name: "Suspicious Contact Detail",
    component: SettingsSuspiciousContactAdd,
  },
  {
    path: "/smsserver/smsserverlist",
    exact: true,
    name: "SMS Server List",
    component: SMSServerList,
    permission: "ADMIN_USERS_ANY_CREATE"
  },
  {
    path: "/smsserver/otplist",
    exact: "true",
    name: "OTP iDeal",
    component: OTPiDeal,
    permission: "ADMIN_USERS_ANY_CREATE"
  },
  {
    path: "/smsserver/addnewsms",
    exact: true,
    name: "Add SMS Server",
    component: SMSServer,
    permission: "ADMIN_USERS_ANY_CREATE"
  },
  {
    path: `/${region}/reports/settlementreports`,
    exact: true,
    name: "ID Settlement Report",
    component: SettlementReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/mdsettlementreport`,
    exact: true,
    name: "MD Settlement Report",
    component: PartnerMerchantReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/merchantsettlementreport`,
    exact: true,
    name: "Merchant Settlement Report",
    component: MerchantSettlementReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/payments`,
    exact: true,
    name: "Payment Report",
    component: PaymentReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/saldokureports`,
    exact: true,
    name: "Saldoku Report",
    component: SaldokuReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/sale/id`,
    exact: true,
    name: "ID Sale Report",
    component: JDSaleReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/sale/digital`,
    exact: true,
    name: "Digital Sale Report",
    component: DigitalSaleReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/refund`,
    exact: true,
    name: "Refund Report",
    component: RefundSaleReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/user`,
    exact: true,
    name: "User Report",
    component: UserReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/payment-order`,
    exact: true,
    name: "Payment Order Report",
    component: PaymentOrderReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/gift`,
    exact: true,
    name: "Gift Report",
    component: GiftReports,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/tokencontactaccess`,
    exact: true,
    name: "Contact Access Report",
    component: TokenContactReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path:`/${region}/reports/chatreport`,
    exact: true,
    name: "Chat Report",
    component: ChatReport
  },
  // {
  //   path: `/attendance/attendancereport`,
  //   exact: true,
  //   name: "TimeSheet",
  //   component: AttendanceReports,
  // },
  // {
  //   path: "/attendance/requestedleave",
  //   exact: true,
  //   name: "Leave",
  //   component: AdminLeaveInfo,
  //   // permission: "ADMIN_REPORTS_ANY_READ"
  // },
  {
    path: `/${region}/reports/salestakeorderreport`,
    exact: true,
    name: "Sales Order Report",
    component: SalesTakeOrderReport,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/merchantsalesreport`,
    exact: true,
    name: "Merchant Sales Report",
    component: MerchantSalesReport,
  },
  {
    path: `/${region}/reports/trendproducts`,
    exact: true,
    name: "Trend Product",
    component: TrendProduct,
  },
  {
    path: `/${region}/reports/collectorreports`,
    exact: true,
    name: "Collector Report",
    component: CollectorReports
  },
  {
    path: `/${region}/searchallorder`,
    exact: true,
    name: "All Order Report",
    component: OrderAllReport
  },
  {
    path: `/${region}/reports/contactnotes`,
    exact: true,
    name: "Contact Notes Report",
    component: LogContactReport
  },
  {
    path: '/affiliator/withdraw-request',
    name: 'Withdraw Request',
    exact: true,
    component: WithdrawRequest,
    permission: "WITHDRAWREQUEST_ANY_READ",
  },
  {
    path: "/affiliator/manage",
    name: "Affiliate",
    exact: true,
    component: Affiliate,
    permission: "AFFILIATE_ANY_READ"
  },
  {
    path: "/affiliate/add",
    name: "Add Affiliate",
    exact: true,
    component: AddAffiliate,
    permission: "AFFILIATE_ANY_CREATE"
  },
  {
    path: "/affiliate/:id",
    name: "Affiliate Detail",
    exact: true,
    component: AffiliateDetail,
    permission: "AFFILIATE_ANY_READ"
  },
  {
    path: "/reports/userlastactive",
    name: "User Last Active",
    exact: true,
    component: UserListLastActive,
  },
  {
    path: "/reports/cmslog",
    exact: true,
    name: "CMS Log",
    component: CMSLogReport,
  },
  {
    path: `/${region}/reports/7elevenreports`,
    exact: true,
    name: "7Eleven Report",
    component: SevelReport,
  },
  {
    path: `/${region}/reports/okmartreports`,
    exact: true,
    name: "OKmart Report",
    component: OKMartReport,
  },
  {
    path: `/${region}/reports/familymartreports`,
    exact: true,
    name: "FamilyMart Report",
    component: FamiliMartReport,
  },
  {
    path: `/${region}/localstore`,
    exact: true,
    name: "Local Store",
    component: LocalStore,
  },
  {
    path: `/${region}/localstore/add`,
    exact: true,
    name: "Add Local Store",
    component: AddLocalStore,
  },
  {
    path: `/${region}/localstore/:id`,
    exact: true,
    name: "Local Store Detail",
    component: AddLocalStore,
  },
  {
    path: `/${region}/translate`,
    exact: true,
    name: "Translate",
    component: Translate,
  },
  {
    path: `/${region}/marketings/giveaway`,
    exact: true,
    name: "Giveaway List",
    component: GiveawayList,
  },
  {
    path: `/${region}/marketings/giveaway/add`,
    exact: true,
    name: "Add Giveaway",
    component: AddGiveaway,
  },
  {
    path: `/${region}/marketings/productpromo`,
    exact: true,
    name: "Products Promo",
    component: ProductsPromo,
  },
  {
    path: `/${region}/marketings/productpromo/add`,
    exact: true,
    name: "Add Products Promo",
    component: AddProductsPromo,
  },
  {
    path: `/${region}/marketings/productpromo/edit/:id`,
    exact: true,
    name: "Edit Products Promo",
    component: AddProductsPromo,
  },
  {
    path: `/${region}/marketings/urlshortener`,
    exact: true,
    name: "URL Shortener",
    component: ShortenLink,
  },
  {
    path: `/${region}/chat`,
    exact: true,
    name: "iDeal Chat",
    component: ChatHome,
  },
  {
    path: `/${region}/chat-messages/:chatId/:userId`,
    exact: true,
    name: "iDeal Chat",
    component: ChatMessages,
  },
  {
    path: `/${region}/reports/creditrecord`,
    exact: true,
    name: "Credit Record Report",
    component: GoodReport,
  },
  {
    path: `/${region}/reports/riskmgmtreport`,
    exact: true,
    name: "Risk MGMT Report",
    component: OAReport
  },
  {
    path: `/${region}/reports/purchasereport`,
    exact: true,
    name: "Purchase Report",
    component: PurchaseReport
  },
  {
    path: `/${region}/reports/purchasereport/add-seller`,
    exact: true,
    name: "Add Seller",
    component: AddSeller,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
  {
    path: `/${region}/reports/purchasereport/edit-seller/:id`,
    exact: true,
    name: "Edit Seller",
    component: AddSeller,
    // permission: "ADMIN_REPORTS_ANY_READ"
  },
];

// add other region path
const ls = reactLocalStorage.getObject(LSNAME.LIST_REGION);
if (!_.isEmpty(ls)) {
  for (let i = 0; i < RegionOption.length; i ++) {
    if (RegionOption[i].value !== region && ls.indexOf(RegionOption[i].value) >= 0 ) {
      routes = routes.concat([
        {
          path: `/${RegionOption[i].value}/users/:userId`,
          exact: true,
          name: "User Details",
          component: User,
          permission: "ADMIN_USERS_ANY_READ"
        },
        {
          path: `/${RegionOption[i].value}/orders/:orderId`,
          exact: true,
          name: "Order Detail",
          component: OrderDetail,
          permission: "ORDERS_ANY_READ"
        },
      ])
    }
  }
  console.log(routes)
}

export default routes;
